export const INVALID_INPUT_STATE = "invalid_input_state";

export const NO_INPUT_STATE = "no_input_state";
